import { $fetch } from "ofetch";
import { appendResponseHeader } from "h3";
import { useRequestEvent, useRequestHeaders } from "#app";
export class HttpRequest {
  baseUrl;
  defaultOptions = {};
  constructor(baseUrl = "", defaultOptions = {}) {
    this.baseUrl = baseUrl;
    this.defaultOptions = defaultOptions;
  }
  async instance(url, options) {
    const event = useRequestEvent();
    const passCookie = options.passCookie ?? this.defaultOptions.passCookie ?? true;
    const req = await $fetch.raw(this.baseUrl + url, this.prepareOptions(options));
    if (passCookie && event) {
      const cookies = (req.headers.get("set-cookie") || "").split(",");
      for (const cookie of cookies) {
        appendResponseHeader(event, "set-cookie", cookie);
      }
    }
    return req._data;
  }
  prepareOptions(options) {
    options = { ...this.defaultOptions, ...options };
    options.headers = { ...options.headers, ...useRequestHeaders(["cookie"]) };
    options.passCookie = void 0;
    return options;
  }
  async get(url, options) {
    return await this.instance(url, {
      ...options,
      method: "GET"
    });
  }
  async post(url, data, options) {
    return await this.instance(url, {
      ...options,
      body: data,
      method: "POST"
    });
  }
  async put(url, data, options) {
    return await this.instance(url, {
      ...options,
      body: data,
      method: "PUT"
    });
  }
  async patch(url, data, options) {
    return await this.instance(url, {
      ...options,
      body: data,
      method: "PATCH"
    });
  }
  async delete(url, data, options) {
    return await this.instance(url, {
      ...options,
      body: data,
      method: "DELETE"
    });
  }
}
